import React, { Suspense } from "react";
import "../../pages/Contact/ContactPage.css";

import Typical from "react-typical";

const Contact = () => (
  <section className="contactos" id="contactos" data-aos="fade-up">
    <h2 className="heading">Contact</h2>

    <h3 className="titulo">
      Contact me by: 
      <Typical
        className="site-contacto"
        loop={Infinity}
        wrapper="b"
        steps={[
          "Gmail", 1500,
          "WhatsApp", 1500,
          "Instagram", 1500,
          "Telegram", 1500,
          "Linkedin", 1500,
          "Github", 1500,
        ]}
      />
    </h3>

    <div className="icons">
      <a href="mailto:abhaypro.cloud@gmail.com">
        <div className="layer">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span className="far fa-envelope"></span>
        </div>
        <div className="text">Gmail</div>
      </a>
      <a href="http://wa.me/916294995876" target="_blank" rel="noopener noreferrer">
        <div className="layer">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span className="fab fa-whatsapp"></span>
        </div>
        <div className="text">WhatsApp</div>
      </a>
      <a href="https://www.instagram.com/abhay_clasher/" target="_blank" rel="noopener noreferrer">
        <div className="layer">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span className="fab fa-instagram"></span>
        </div>
        <div className="text">Instagram</div>
      </a>
      <a href="https://t.me/para_toxic69" target="_blank" rel="noopener noreferrer">
        <div className="layer">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span className="fab fa-telegram"></span>
        </div>
        <div className="text">Telegram</div>
      </a>
      <a href="https://www.linkedin.com/in/abhayclasher/" target="_blank" rel="noopener noreferrer">
        <div className="layer">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span className="fab fa-linkedin-in"></span>
        </div>
        <div className="text">LinkedIn</div>
      </a>
      <a href="https://github.com/abhayclasher" target="_blank" rel="noopener noreferrer">
        <div className="layer">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span className="fab fa-github-square"></span>
        </div>
        <div className="text">GitHub</div>
      </a>
    </div>
  </section>
);

export default Contact;
